import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";

import { addCurrency,ObtenerCurrency } from "../../../../API/Global/Currency/CurrencyRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import Loader from "../../../../Components/Loader/Loader";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";

const CurrencyCrudModal = ({
  toastRef,
  moneda,
  monedasDialog,
  setMonedasDialog,
  getMonedas,
  modo,
}) => {
  const toast = useRef(null);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [currency, setCurrency] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const { userAuth } = useContext(AuthContext  );

  const initialValues = {
    IdCurrency: moneda ? moneda?.IdCurrency : -1,
    Currency: "",
    CurrencySymbol: "",
    IdStatus: moneda ? moneda?.IdStatus : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const cur = await ObtenerCurrency();
    setCurrency(cur);


    // Si el modo es "Crear", establece el primer estado como valor inicial
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === moneda?.IdStatus);

    setValues({
      ...moneda,
      IdCurrency: moneda ? moneda?.IdCurrency : -1,
      Estado: estadoInicial, // Establece el estado inicial
      IdStatus: estadoInicial.IdStatus, // Establece el IdStatus en values
    });
    setLoading(false)
  };

  const onHide = () => {
    setMonedasDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Currency) {
      error.Currency = true;
      error.error = true;
    }
    if (!values.CurrencySymbol) {
      error.CurrencySymbol = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
        error.IdStatus = true;
        error.error = true;
      }
    setError(error);
    return error;
  };

  const agregarMoneda = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingCurrency = currency.find(
        (cur) => cur.Currency === values?.Currency
      );
      if (existingCurrency && (modo === "Crear" &&  existingCurrency.IdCurrency !== values.IdCurrency)) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una Moneda con ese nombre"
        );
      }else{
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdCurrency: values?.IdCurrency,
          Currency: values.Currency,
          CurrencySymbol: values.CurrencySymbol,
          IdStatus: estadoId,
          IdUserCreate: userAuth?.IdUser
        };
        const resultado = await addCurrency(a);
        if(resultado[0]?.ESTADO === 1){
          setLoading(true)
          toastShow(
            toast,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          getMonedas()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 500);
        }else{
          toastShow(
            toast,
            "error",
            "Error",
            resultado[0]?.MENSAJE
          );
        }
      }
    } else {
      toastShow(toast, "error", "Error", "Error al editar la informacion");
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarMoneda();
          } else {
            agregarMoneda();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (monedasDialog) {
      getValoresIniciales();
    }
  }, [monedasDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Moneda" : "Modificar Moneda";

  return (
    <div>
      <Dialog
        visible={monedasDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="CurrencyDialog">
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <ConfirmDialog />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Loader loading={loading} querySelector={"#CurrencyDialog"} />
          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Currency"
                  value={values.Currency}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Currency ? "p-invalid" : ""}
                />
                <label htmlFor="NombreProducto">Moneda</label>
                {error.Currency && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Nombre de la Moneda es requerido.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="CurrencySymbol"
                  value={values.CurrencySymbol}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                />
                <label htmlFor="CurrencySymbol">Símbolo</label>
                {error.CurrencySymbol && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Simbolo es requerido.
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Estado ? "p-invalid" : ""}
                />
                {error.IdStatus && (
                  <small
                    className="p-error block"
                    style={{ position: "absolute", top: 41 }}
                  >
                    Seleccione un estado.
                  </small>
                )}
              </span>
            </div>
          </div>
        </div>

        </div>
      </Dialog>
    </div>
  );
};

export default CurrencyCrudModal;
